import { initializeApp } from "firebase/app";
import { getMessaging, getToken, onMessage } from "firebase/messaging";

const firebaseConfig = {
  apiKey: "AIzaSyC9phEB_gtNPSR65Q0iAm9JYk73MKGestg",
  authDomain: "i-cpts-du-val.firebaseapp.com",
  projectId: "i-cpts-du-val",
  storageBucket: "i-cpts-du-val.appspot.com",
  messagingSenderId: "397389535812",
  appId: "1:397389535812:web:be4165104d0ef57b497a11",
  measurementId: "G-3BPT723BKR"
};

const app = initializeApp(firebaseConfig);
const messaging = getMessaging(app);

export { messaging, getToken, onMessage };
